import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-unspecified-item-specify',
    templateUrl: './question-unspecified-item-specify.component.html',
    styleUrls: ['./question-unspecified-item-specify.component.scss'],
    standalone: false
})
export class QuestionUnspecifiedItemSpecifyComponent implements OnInit {

  @Input() question: Question;
  @Input() readonly = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `unspecified-item-specify-${newGuid()}`;

  constructor() { }

  ngOnInit(): void {

  }

}
